import request from '@/utils/request'

// 登录
export function login(data) {
  return request({
    url: '/system/auth/login',
    method: 'POST',
    data,
    headers: {
      isEncrypt: false,
      isToken: false
    }
  })
}

// 使用租户名，获得租户编号
export function getTenantIdByName(name) {
  return request({
    url: '/system/tenant/get-id-by-name?name=' + name,
    method: 'get'
  })
}

// 使用租户域名，获得租户信息
export function getTenantByWebsite(website) {
  return request({
    url: '/system/tenant/get-by-website?website=' + website,
    method: 'get'
  })
}

// 登出
export function loginOut() {
  return request({
    url: '/system/auth/logout',
    method: 'post'
  })
}

// 获取用户权限信息
export function getInfo() {
  return request({
    url: '/system/auth/get-permission-info',
    method: 'get'
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/system/auth/get-user-info',
    method: 'get'
  })
}

